<div
    [formGroup]="metadata"
    class="agpr-topMentionMetadataField"
>
    <div formGroupName="metadataTypes">
        <div class="agpr-topMentionsMetadataField-twoColumn">
            <div class="agpr-topMentionsMetadataField-twoColumn-left">
                <agpr-checkbox
                    formControlName="mediaType"
                    [id]="'topMentionsMetadata_mediaType'"
                    label="Reports.topMentions.metadata.mediaType"
                    [binary]="true"
                ></agpr-checkbox>
                <agpr-checkbox
                    formControlName="outlet"
                    [id]="'topMentionsMetadata_outlet'"
                    label="Reports.topMentions.metadata.outlet"
                    [binary]="true"
                ></agpr-checkbox>
                <agpr-checkbox
                    formControlName="author"
                    [id]="'topMentionsMetadata_author'"
                    label="Reports.topMentions.metadata.author"
                    [binary]="true"
                ></agpr-checkbox>
                <agpr-checkbox
                    formControlName="duration"
                    [id]="'topMentionsMetadata_duration'"
                    label="Reports.topMentions.metadata.duration"
                    [binary]="true"
                ></agpr-checkbox>
                <agpr-checkbox
                    formControlName="keywords"
                    [id]="'topMentionsMetadata_keywords'"
                    label="Reports.topMentions.metadata.keywords"
                    [binary]="true"
                ></agpr-checkbox>
            </div>

            <div class="agpr-topMentionsMetadataField-twoColumn-right">
                <div [formGroup]="mentionContent">
                    <agpr-checkbox
                        formControlName="showSnippet"
                        [id]="'topMentionsMetadata_showSnippet'"
                        label="Reports.topMentions.metadata.snippet"
                        [binary]="true"
                    ></agpr-checkbox>
                    <div
                        class="agpr-topMentionsMetadataField-subOption"
                        [ngClass]="{ 'agpr-topMentionsMetadataField--hidden': !showSnippet }"
                    >
                        <agpr-radio
                            formControlName="lead"
                            [id]="'topMentionsMetadata_lead'"
                            label="Reports.topMentions.metadata.lead"
                            [value]="mentionContentCustomizations.lead"
                        ></agpr-radio>
                        <agpr-radio
                            formControlName="summary"
                            [id]="'topMentionsMetadata_summary'"
                            label="Reports.topMentions.metadata.summary"
                            [value]="mentionContentCustomizations.summary"
                        ></agpr-radio>
                    </div>
                </div>
                <agpr-checkbox
                    formControlName="wordCount"
                    [id]="'topMentionsMetadata_wordCount'"
                    label="Reports.topMentions.metadata.wordCount"
                    [binary]="true"
                ></agpr-checkbox>
                <agpr-checkbox
                    formControlName="domainAuthority"
                    [id]="'topMentionsMetadata_domainAuthority'"
                    label="Reports.topMentions.metadata.domainAuthority"
                    [binary]="true"
                ></agpr-checkbox>
            </div>
        </div>

        <agpr-checkbox
            [formControl]="highlightKeywords"
            [id]="'topMentionsMetadata_highlightKeywords'"
            label="Reports.topMentions.metadata.highlightKeywords"
            [binary]="true"
        ></agpr-checkbox>

        <agpr-checkbox
            formControlName="publishedDate"
            [id]="'topMentionsMetadata_publishedDate'"
            [label]="'Reports.topMentions.metadata.publishedDate'"
            [binary]="true"
        ></agpr-checkbox>

        <div
            class="agpr-topMentionsMetadataField-subOption"
            [ngClass]="{ 'agpr-topMentionsMetadataField--hidden': !showTimezonePicker }"
        >
            <agpr-timezone-picker
                [formControl]="timezone"
                [id]="'topMentionsMetadata_timezone'"
            ></agpr-timezone-picker>
        </div>

        <div [formGroup]="insights">
            <agpr-checkbox
                formControlName="showInsights"
                [id]="'topMentionsMetadata_showInsights'"
                label="Reports.topMentions.metadata.showInsights"
                [binary]="true"
            ></agpr-checkbox>
            <div
                class="agpr-topMentionsMetadataField-subOption"
                [ngClass]="{ 'agpr-topMentionsMetadataField--hidden': !showInsights }"
            >
                <agpr-radio
                    formControlName="insightsName"
                    [id]="'topMentionsMetadata_insightsName'"
                    label="Reports.topMentions.metadata.insightsName"
                    [value]="insightsDisplayNameTypes.insightsName"
                ></agpr-radio>
                <agpr-radio
                    formControlName="custom"
                    [id]="'topMentionsMetadata_custom'"
                    label="Reports.topMentions.metadata.customInsightsName"
                    [value]="insightsDisplayNameTypes.custom"
                ></agpr-radio>
                <div
                    class="agpr-topMentionsMetadataField-subOption"
                    [ngClass]="{ 'agpr-topMentionsMetadataField--hidden': !isCustomInsightsName }"
                >
                    <agpr-text-input
                        formControlName="customInsightsName"
                        [id]="'topMentionsMetadata_customInsightsName'"
                        placeholder="Reports.topMentions.metadata.customInsightsName.placeholder"
                    ></agpr-text-input>
                </div>
            </div>
        </div>

        <h4 class="agpr-topMentionsMetadataField-dataDisplay-heading">{{ 'Reports.topMentions.metadata.dataDisplay' | localize }}</h4>

        <agpr-checkbox
            formControlName="audienceReach"
            [id]="'topMentionsMetadata_audienceReach'"
            label="Reports.topMentions.metadata.audienceReach"
            [binary]="true"
        ></agpr-checkbox>
        <agpr-checkbox
            formControlName="ave"
            [id]="'topMentionsMetadata_ave'"
            label="Reports.topMentions.metadata.ave"
            [binary]="true"
        ></agpr-checkbox>
        <div
            class="agpr-topMentionsMetadataField-subOption"
            [ngClass]="{ 'agpr-topMentionsMetadataField--hidden': !showCurrencySelector }"
        >
            <agpr-autocomplete
                [formControl]="currency"
                [id]="'topMentionsMetadata_currency'"
                [suggestions]="currencySuggestions$"
                labelField="label"
                [dropdown]="true"
                [clearOnBlur]="false"
                [minLength]="1"
                ariaLabel="Reports.topMentions.metadata.currency"
            ></agpr-autocomplete>
        </div>
    </div>
</div>
